// 从@/pages/intelligence/components/TableComponents/SortBy'迁移

import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useMemo } from 'react';
import { Dropdown, DropdownProps, List } from 'tea-component';
import './index.scss';
import { useIntl } from 'umi';

type SortType = 'asc' | 'desc' | 'sort';
const sortIconMap: {
  [key in SortType]: string;
} = {
  sort: 'sort-icon',
  asc: 'arrow-big-up',
  desc: 'arrow-big-down',
};

export default function HoverSortCommonSimple({
  children,
  sort,
  sortChange,
  sortKey = '',
  className = '',
  dropdownProps,
  isActive,
  titleLeft = false,
  sortLabel
}: {
  children: JSX.Element | string;
  sort: { by: string; order: SortType; };
  sortKey?: string;
  sortChange: (sortItem?: { by: string; order: SortType; }) => void;
  className?: string;
  isActive?: boolean;
  dropdownProps?: Omit<DropdownProps, 'button' | 'children'>;
  titleLeft?: boolean;
  sortLabel?: string;
}) {
  const { formatMessage } = useIntl();
  const [by, order]: [string, SortType] = useMemo(() => {
    let map: any = {};
    if (sortKey === sort.by) {
      map = sort;
    }
    return [map.by, map.order];
  }, [sort, sortKey]);

  // sort改变的方法
  const changeSort = (order: SortType) => {
    if (order === 'sort') {
      sortChange({});
      return;
    }

    const changeSortObj = { by: sortKey, order };

    sortChange(changeSortObj);
  };

  const sortOptions: Array<{ order: SortType; text: string }> = [
    { order: 'asc', text: 'Asc' },
    { order: 'desc', text: 'Des' },
    { order: 'sort', text: 'Default Sorting' },
  ];

  // 多选的泡泡内容
  const menu = useMemo(() => {
    const getClassName = (currentOrder: string) => {
      if (order === currentOrder || (!order && currentOrder === 'sort')) {
        return 'active';
      }
      return '';
    };
    return (
      <List type="option">
        {sortOptions.map(
          ({ order, text }: { order: SortType; text: string }) => {
            return (
              <List.Item
                selected={getClassName(order) == 'active'}
                className={getClassName(order)}
                key={order}
                onClick={() => changeSort(order)}
              >
                <SvgIcon type={sortIconMap[order]} className="text-icon" />
                <span className="option-text-info">
                  {formatMessage({ id: text })}
                </span>
              </List.Item>
            );
          },
        )}
      </List>
    );
  }, [sortOptions, order]);

  const isSelected = useMemo(() => {
    return isActive ?? Boolean(by);
  }, [sort, isActive]);

  return (
    <div className={`dbo-table-header-flex  ${titleLeft ? '' : 'right'} ${className}`} >
      <Dropdown
        boxClassName="dbo-sort-by"
        className="dbo-sort-table"
        appearance="pure"
        trigger="hover"
        // trigger="click"
        {...(dropdownProps || {})}
        button={
          <div className={isSelected ? 'active' : ''}>
            <span
              className={
                isSelected ? 'active table-header-text' : 'table-header-text'
              }
            >
              {children}
            </span>
            <SvgIcon
              type={sortIconMap[order] || 'icon-arrow-down'}
              className={`table-header-tip  ${isSelected ? 'action-icon' : ''}`}
            />
          </div>
        }
      >
        {sortLabel &&
          <span className="table-header-tip-label">
            {sortLabel}
          </span>
        }
        <List type="option">{menu}</List>
      </Dropdown>
    </div>
  );
}
